import ServiceWorkerContext from './ServiceWorkerContext';

const ServiceWorkerConsumer = ServiceWorkerContext.Consumer;

export default ServiceWorkerConsumer;
